import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { RdsService } from '../../service';

export type EncryptionConfig = typeof EncryptionConfig._.Config;

export const EncryptionConfig = IntegrationConfig.make({
  service: RdsService,
  name: Integration_Handler_Names_Enum.Encryption,
  configSchema: z.object({
    dbClusterIds: z.array(z.string().min(1)).optional(),
    dbInstanceIds: z.array(z.string().min(1)).optional(),
  }),
});
